import { defineAction } from '~/prix'
import { z } from 'zod'
import complementaryRoadUpdateAction from './complementaryRoadUpdate.action.json' with { type: 'json' }
import { complementaryRoadUpdateInput } from '../complementaryRoadObject'

const complementaryRoadUpdateDefinition = defineAction({
  ...complementaryRoadUpdateAction,
  input: complementaryRoadUpdateInput,
  output: z.object({}),
})

export default complementaryRoadUpdateDefinition
